import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import { of } from 'rxjs';
import { loadAllMitarbeiterFailed, loadAllMitarbeiterStart, loadAllMitarbeiterSucceeded } from '../actions/getAllMitarbeiter.actions';
import {MitarbeiterService} from '../../mitarbeiter.service';
import {addMitarbeiterFailed, addMitarbeiterStart, addMitarbeiterSucceeded} from '../actions/mitarbeiter-add.actions';
import {editMitarbeiterFailed, editMitarbeiterStart, editMitarbeiterSucceeded} from '../actions/mitarbeiter-edit.actions';
import {loadUserStart} from '../../../landingpage/store/actions/getUser.actions';
import {deleteMitarbeiterFailed, deleteMitarbeiterStart, deleteMitarbeiterSucceeded} from '../actions/mitarbeiter-del.actions';
import {
  getFilteredMitarbeiterFailed,
  getFilteredMitarbeiterStart,
  getFilteredMitarbeiterSucceeded
} from '../actions/getFilteredMitarbeiter.actions';
import {
  reactivateMitarbeiterFailed,
  reactivateMitarbeiterStart,
  reactivateMitarbeiterSucceeded
} from '../actions/mitarbeiter-reactivate.actions';
import {
  loadAllMitarbeiterSelectboxFailed,
  loadAllMitarbeiterSelectboxStart,
  loadAllMitarbeiterSelectboxSuceeded
} from "../actions/getAllMitarbeiterSelectbox.actions";
import {HttpClient} from "@angular/common/http";
import {stringify} from "@angular/compiler/src/util";
import {
  loadFirmaZeitenFailed,
  loadFirmaZeitenStart,
  loadFirmaZeitenSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFirmaZeiten.actions';
import {loadSaldoFailed, loadSaldoStart, loadSaldoSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getSaldo.actions';
import {
  deleteRolleFailed,
  deleteRolleStart,
  deleteRolleSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/rolle-del.actions';
import {loadRollenStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/rolle.actions';
import {
  loadUserInfoFailed,
  loadUserInfoStart,
  loadUserInfoSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getUserInfo.actions';
import {
  addFirmaZeitFailed,
  addFirmaZeitStart,
  addFirmaZeitSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-add.actions';
import {
  addUserInfoFailed,
  addUserInfoStart,
  addUserInfoSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/userInfo-add.actions';
import {deleteUserInfoStart, deleteUserInfoSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/saldo-del.actions';
import {
  editFeiertageFailed,
  editFeiertageStart,
  editFeiertageSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/feiertage-edit.actions';
import {loadFeiertageStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFeiertage.actions';
import {
  editUserInfoFailed,
  editUserInfoStart,
  editUserInfoSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/userInfo-edit.actions';

@Injectable()
export class MitarbeiterEffects {
    /**
     * Loads the address list when dispatching the start action
     */
    public loadUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadAllMitarbeiterStart),
            mergeMap((mitarbeiterStartAction) =>
                this.mitarbeiterService.getAllMitarbeiter(mitarbeiterStartAction.string).pipe(
                    map((response) => loadAllMitarbeiterSucceeded({ item: response.data })),
                    catchError((e) => of(loadAllMitarbeiterFailed(e))),
                ),
            ),
        ),
    );

  public loadSaldo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSaldoStart),
      mergeMap((userId) =>
        this.mitarbeiterService.getSaldo(userId.userId).pipe(
          map((response) => loadSaldoSucceeded({ item: response })),
          catchError((e) => of(loadSaldoFailed(e))),
        ),
      ),
    ),
  );

  public loadUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserInfoStart),
      mergeMap((userId) =>
        this.mitarbeiterService.getUserInfo(userId.userId, userId.showYears).pipe(
          map((response) => loadUserInfoSucceeded({ item: response.data })),
          tap((item) => sessionStorage.setItem('showYear', userId.showYears.toString() )),
          catchError((e) => of(loadUserInfoFailed(e))),
        ),
      ),
    ),
  );

  public addUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addUserInfoStart),
      mergeMap((userInfo) =>
        this.mitarbeiterService.addUserInfo(userInfo.userInfo).pipe(
          // tslint:disable-next-line:radix
          mergeMap((response) => of(addUserInfoSucceeded({ item: response }), loadUserInfoStart({userId: response.userId, showYears: parseInt(sessionStorage.getItem('showYear'))}))),
          catchError((e) => of(addUserInfoFailed(e))),
        ),
      ),
    ),
  );

  public editUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editUserInfoStart),
      mergeMap((userInfo) =>
        this.mitarbeiterService.editUserInfo(userInfo.item).pipe(
          // tslint:disable-next-line:triple-equals radix
          mergeMap((response) => of(editUserInfoSucceeded({ item: response }), loadUserInfoStart({userId: response.userId, showYears: parseInt(sessionStorage.getItem('showYear'))}))),
          catchError((e) => of(editUserInfoFailed(e))),
        ),
      ),
    ),
  );

  public deleteUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteUserInfoStart),
      mergeMap((value) =>
        this.mitarbeiterService.deleteUserInfo(value.item, value.userId).pipe(
          // tslint:disable-next-line:radix
          mergeMap((response) => of(deleteUserInfoSucceeded(), loadUserInfoStart({userId: response, showYears: parseInt(sessionStorage.getItem('showYear'))}))),
          catchError((e) => of(deleteMitarbeiterFailed(e))),
        ),
      ),
    ),
  );

  public loadUserSelectbox$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAllMitarbeiterSelectboxStart),
      mergeMap((mitarbeiterStartAction) =>
        this.mitarbeiterService.getAllMitarbeiterSelectbox(mitarbeiterStartAction.string).pipe(
          map((response) => loadAllMitarbeiterSelectboxSuceeded({ item: response.data })),
          catchError((e) => of(loadAllMitarbeiterSelectboxFailed(e))),
        ),
      ),
    ),
  );

  public addUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addMitarbeiterStart),
      mergeMap((mitarbeiterStartAction) =>
        this.mitarbeiterService.add(mitarbeiterStartAction.item).pipe(
          mergeMap((response) => of(
            addMitarbeiterSucceeded({ item: response }),
            //getFilteredMitarbeiterStart({string: sessionStorage.getItem('mitarbeiterSearchString'), item: {search: sessionStorage.getItem('mitarbeiterSuche'), deleted: Boolean(sessionStorage.getItem('mitarbeiterDeaktiviert'))}})
            // neuem User Passwort zuschicken
            )),
          tap(() =>
            this.http.get
          (
            `https://local.curion.ch/AccMan/addacc.php?app=1003&email=${mitarbeiterStartAction.item.email}`,
            {responseType: 'text'}
          ).subscribe(),
            ),
          catchError((e) => of(addMitarbeiterFailed(e))),
        ),
      ),
    ),
);

  public editUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editMitarbeiterStart),
      mergeMap((mitarbeiterStartAction) =>
        this.mitarbeiterService.edit(mitarbeiterStartAction.item).pipe(
          mergeMap((response) => of(editMitarbeiterSucceeded({ item: response }),
            getFilteredMitarbeiterStart({string: sessionStorage.getItem('mitarbeiterSearchString'), item: {search: sessionStorage.getItem('mitarbeiterSuche'), deleted: Boolean(sessionStorage.getItem('mitarbeiterDeaktiviert'))}}),
            loadUserStart({email: sessionStorage.getItem('email')}))),
          catchError((e) => of(editMitarbeiterFailed(e))),
        ),
      ),
    ),
  );

  public deleteUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteMitarbeiterStart),
      mergeMap((mitarbeiterStartAction) =>
        this.mitarbeiterService.delete(mitarbeiterStartAction.item).pipe(
          // tslint:disable-next-line:max-line-length
          mergeMap((response) => of(deleteMitarbeiterSucceeded(),  loadUserStart({email: sessionStorage.getItem('email')}),
            getFilteredMitarbeiterStart({string: sessionStorage.getItem('mitarbeiterSearchString'), item: {search: sessionStorage.getItem('mitarbeiterSuche'), deleted: Boolean(sessionStorage.getItem('mitarbeiterDeaktiviert'))}}),
            )),
          catchError((e) => of(deleteMitarbeiterFailed(e))),
        ),
      ),
    ),
  );

  public reactivateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reactivateMitarbeiterStart),
      mergeMap((mitarbeiterStartAction) =>
        this.mitarbeiterService.reactivate(mitarbeiterStartAction.item).pipe(
          // tslint:disable-next-line:max-line-length
          mergeMap((response) => of(reactivateMitarbeiterSucceeded(),
            getFilteredMitarbeiterStart({string: sessionStorage.getItem('mitarbeiterSearchString'), item: {search: sessionStorage.getItem('mitarbeiterSuche'), deleted: Boolean(sessionStorage.getItem('mitarbeiterDeaktiviert'))}}),
            loadUserStart({email: sessionStorage.getItem('email')}))

          ),
          catchError((e) => of(reactivateMitarbeiterFailed(e))),
        ),
      ),
    ),
  );

  public loadFilteredMitarbeiter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFilteredMitarbeiterStart),
      mergeMap((projekt) =>
        this.mitarbeiterService.getFilteredMitarbeiter(projekt.string, projekt.item).pipe(
          mergeMap((response) => of(getFilteredMitarbeiterSucceeded({ item: response.data}))),
          catchError((e) => of(getFilteredMitarbeiterFailed(e))),
        ),
      ),
    ),
  );






    /**
     * Constructor of address effects
     *
     * @param actions$ - The action observable
     * @param addressesService - The address service
     */
    constructor(private actions$: Actions, private mitarbeiterService: MitarbeiterService, private http: HttpClient) {}
}
